var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.333 0.666504C26.083 10.8727 34.1269 18.9165 44.333 22.6665C34.1269 26.4165 26.083 34.4604 22.333 44.6665C18.583 34.4604 10.5392 26.4165 0.333008 22.6665C10.5392 18.9165 18.583 10.8727 22.333 0.666504Z",
    fill: "#027EF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceStar);
export default __webpack_public_path__ + "static/media/service-star.4c41b73266ca25805dd546c214560dfe.svg";
export { ForwardRef as ReactComponent };